<!--
 * @Author: pyy
 * @Date: 2022-09-16
 * @Description: 项目统计-折柱图
-->
<template>
	<div class="line-bar-chart h100 pdt10">
		<div ref="myChart"
			 style="width: 100%; height: 100%"></div>
	</div>
</template>

<script>
import * as echarts from 'echarts'
import * as API from '@/api/FormManager/FormManager'
import { mapState } from 'vuex'
import { html2canvasExport } from '@/utils/tools'

export default {
	props: {
		apiParams: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			chart: null,
			options: {
				color: ['#6666ff', '#66cc99', '#ff6600', '#ffcc33'],
				legend: {
					textStyle: {
						fontSize: 12,
						color: '#888',
					},
					top: '5',
				},
				grid: {
					left: '3%',
					right: '3%',
					top: '80',
					bottom: '40',
					containLabel: true,
				},
				tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255, 255, 255, 1)',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: '#6a7985',
						},
					},
					padding: [5, 10, 5, 10],
					formatter: function (params) {
						return (
							params[0].axisValue +
							`<br>` +
							params
								.map((item) => {
									let str = `<span style="display:inline-block;width:20px;height:12px;margin: 0 8px 0 -3px;border-radius:2px;background-color:${item.color};"></span>`
									if (item.componentSubType === 'line') {
										str = `<span style="display:inline-block; width: 5px;height: 2px; margin: 0 -5px 5px -3px;background-color: ${item.color}"></span>
											   <span style="display:inline-block; width:12px;height:12px; border-radius:50%;border: 2px solid ${item.color};"></span>
											   <span style="display:inline-block; width: 5px;height: 2px; margin: 0 7px 5px -5px;background-color: ${item.color}"></span>`
									}
									let seriesNameStr = `<span style="display:inline-block;">${item.seriesName}</span>`
									let value = item.value[item.encode.y[0]]
									let valueStr = `<span style="display:inline-block;margin-left:20px;font-weight: bold">${value}</span>`
									return `<span style="display:flex; justify-content:space-between; margin-bottom: 2px">
												<span>${str}${seriesNameStr}</span>
												<span>${valueStr}</span>
											</span>`
								})
								.join(``)
						)
					},
				},
				xAxis: { type: 'category' },
				yAxis: {
					type: 'value',
					axisLabel: {
						formatter: '{value} 万元',
					},
				},
				series: [
					{ type: 'bar', datasetIndex: 0, barWidth: 19 },
					{ type: 'bar', datasetIndex: 0, barWidth: 19 },
					{ type: 'bar', datasetIndex: 0, barWidth: 19 },
					{ type: 'bar', datasetIndex: 0, barWidth: 19 },
					{ type: 'line', datasetIndex: 1, smooth: true },
					{ type: 'line', datasetIndex: 1, smooth: true },
					{ type: 'line', datasetIndex: 1, smooth: true },
					{ type: 'line', datasetIndex: 1, smooth: true },
				],
				dataset: [
					{
						source: [
							[
								'product',
								'片区当月总计划完成产值',
								'片区当月总申报完成产值',
								'片区当月总审核完成产值',
								'片区当月总实际付款',
							],
						],
					},
					{
						source: [
							[
								'product',
								'片区累计总计划完成产值',
								'片区累计总申报完成产值',
								'片区累计总审核完成产值',
								'片区累计总实际付款',
							],
						],
					},
				],
			},
			options2: null,
		}
	},
	created() {
		this.options2 = this.$utils.clone(this.options, true)
	},
	mounted() {
		window.addEventListener('resize', () => {
			setTimeout(() => {
				if (!!this.chart) {
					this.chart.resize()
				}
			}, 300)
		})
	},
	methods: {
		_getData() {
			API.getProjectStatisticsToFoldColumnDiagram(this.apiParams).then(
				(res) => {
					if (!!res.data) {
						if (this.apiParams.moduleType == '') {
							// 产值：全部
							const barData = res.data.total.map((item) => {
								const {
									mon = '',
									plan = '0',
									declare = '0',
									examine = '0',
									actual = '0',
								} = item
								return [mon, plan, declare, examine, actual]
							})
							const lineData = res.data.total.map((item) => {
								const {
									mon = '',
									planTotal = '0',
									declareTotal = '0',
									examineTotal = '0',
									actualTotal = '0',
								} = item
								return [
									mon,
									planTotal,
									declareTotal,
									examineTotal,
									actualTotal,
								]
							})
							this.options.dataset[0].source = [
								[
									'product',
									'片区当月总计划完成产值',
									'片区当月总申报完成产值',
									'片区当月总审核完成产值',
									'片区当月总实际付款',
								],
								...barData,
							]
							this.options.dataset[1].source = [
								[
									'product',
									'片区累计总计划完成产值',
									'片区累计总申报完成产值',
									'片区累计总审核完成产值',
									'片区累计总实际付款',
								],
								...lineData,
							]
						} else {
							let seriesArr1 = []
							let seriesArr2 = []

							let legendArr1 = []
							let legendArr2 = []

							// 产值类型
							const outputType =
								this.outputOptions[this.apiParams.moduleType]

							// 区域数量
							const keys = Object.keys(
								res.data.aloneData[0]
							).filter((i) => !i.includes('Total') && i !== 'mon')
							console.log(keys)

							// 一格中柱状图数量
							seriesArr1 = Array(keys.length).fill({
								type: 'bar',
								datasetIndex: 0,
								barWidth: 19,
							})
							// 一格中折线图数量
							seriesArr2 = Array(keys.length).fill({
								type: 'line',
								datasetIndex: 1,
								smooth: true,
							})
							this.options2.series = [
								...seriesArr1,
								...seriesArr2,
							]

							// 用别名找到区域名称
							let area = {}
							keys.map((k) => {
								area = this.projectDict.xmgsqy.find(
									(i) => i.alias === k
								)

								// 柱状图 图例数量
								legendArr1.push(
									area.sname + '当月' + outputType
								)
								// 折线图 图例数量
								legendArr2.push(
									area.sname + '累计' + outputType
								)
							})

							const barData = res.data.aloneData.map((item) => {
								const totalValues = keys.map((i) => item[i])
								return [item.mon, ...totalValues]
							})
							const lineData = res.data.aloneData.map((item) => {
								const totalValues = keys.map(
									(i) => item[i + 'Total']
								)
								return [item.mon, ...totalValues]
							})

							this.options2.dataset[0].source = [
								['product', ...legendArr1],
								...barData,
							]
							this.options2.dataset[1].source = [
								['product', ...legendArr2],
								...lineData,
							]
						}

						setTimeout(() => {
							this.initChart()
						}, 200)
					}
				}
			)
		},

		initChart() {
			this.chart = echarts.init(this.$refs.myChart)
			// 设置不同的配置
			if (this.apiParams.moduleType == '') {
				this.chart.setOption(this.options, true)
			} else {
				this.chart.setOption(this.options2, true)
			}
		},

		download(fileName) {
			if (this.$refs.myChart) {
				html2canvasExport(this.$refs.myChart, fileName)
			}
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
		outputOptions() {
			return {
				0: '计划完成产值',
				1: '申报完成产值',
				2: '审核完成产值',
				3: '实际付款',
			}
		},
	},
	watch: {
		apiParams: {
			handler(newVal) {
				if (newVal.unit == 0) {
					this.options.yAxis.axisLabel = {
						formatter: '{value} 元',
					}
					this.options2.yAxis.axisLabel = {
						formatter: '{value} 元',
					}
				} else if (newVal.unit == 1) {
					this.options.yAxis.axisLabel = {
						formatter: '{value} 万元',
					}
					this.options2.yAxis.axisLabel = {
						formatter: '{value} 万元',
					}
				}

				this._getData()
			},
			deep: true,
		},
	},
}
</script>

<style>
</style>